import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { visitTemplatesTranslationKeys } from '../../translations';
import { VisitTemplateInsert } from '../VisitTemplates.types';

import { StyledVisitTemplateReadOnly } from './VisitTemplateReadOnly.styled';
import { VisitTemplateReadOnlyField } from './VisitTemplateReadOnlyField';

type VisitTemplateReadOnlyProps = {
   readonly item: VisitTemplate;
   readonly onInsert?: VisitTemplateInsert;
};

export const VISIT_TEMPLATE_DETAIL_TYPES_MAX_LENGTH = 3;

export const VisitTemplateReadOnly = (props: VisitTemplateReadOnlyProps): JSX.Element => {
   const { onInsert, item } = props;

   return (
      <>
         <StyledVisitTemplateReadOnly>
            <VisitTemplateReadOnlyField
               label={visitTemplatesTranslationKeys.interview}
               value={item.interview ?? undefined}
               placeholder={visitTemplatesTranslationKeys.noInterview}
               onInsert={onInsert}
               templateId={item.id}
               detailType={'interview'}
            />
            <VisitTemplateReadOnlyField
               label={visitTemplatesTranslationKeys.subjectiveAssessment}
               value={item.physicalExamination ?? undefined}
               placeholder={visitTemplatesTranslationKeys.noSubjectiveAssessments}
               templateId={item.id}
               onInsert={onInsert}
               detailType={'physicalExamination'}
            />
            <VisitTemplateReadOnlyField
               label={visitTemplatesTranslationKeys.recommendations}
               value={item.recommendations ?? undefined}
               placeholder={visitTemplatesTranslationKeys.noRecommendations}
               onInsert={onInsert}
               templateId={item.id}
               detailType={'recommendations'}
            />
         </StyledVisitTemplateReadOnly>
      </>
   );
};
